module.exports = __webpack_public_path__ + "img/Logo.cd588441.png";